import { render } from "./ProfileHeader.vue?vue&type=template&id=ba899536&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=ba899536&lang=scss&global=true"
import "./ProfileHeader.vue?vue&type=style&index=1&id=ba899536&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba899536"]])

export default __exports__